import { createFeatureSelector, createSelector } from '@ngrx/store';
import { groupsAdapter, GROUPS_FEATURE_KEY, State } from './groups.reducer';

export const getGroupsState = createFeatureSelector<State>(GROUPS_FEATURE_KEY);

const { selectAll, selectEntities } = groupsAdapter.getSelectors();

export const getGroupsLoaded = createSelector(getGroupsState, (state: State) => state.loaded);
export const getSaveGroupLoaded = createSelector(getGroupsState, (state: State) => state.loadedSaveGroup);

export const getGroupsError = createSelector(getGroupsState, (state: State) => state.error);

export const getAlreadyImportedGroup = createSelector(getGroupsState, (state: State) => state.alreadyImportedGroup);

export const getAllGroups = createSelector(getGroupsState, (state: State) => selectAll(state));

export const getSelectedGroup = createSelector(getGroupsState, (state: State) => state.selectedGroup);

export const getSelectedStudent = createSelector(getGroupsState, (state: State) => state.selectedStudent);

export const getStudentsGroup = createSelector(getGroupsState, (state: State) => state.students);
export const getEditableStudentsGroup = createSelector(getGroupsState, (state: State) => state.editableStudents);
export const getEditableGroup = createSelector(getGroupsState, (state: State) => state.editableGroup);
export const getAllTeachers = createSelector(getGroupsState, (state: State) => state.allTeachers);

export const getFailedStudents = createSelector(getGroupsState, (state: State) => state.failedStudents);
export const getSuccessStudents = createSelector(getGroupsState, (state: State) => state.successStudents);
export const getFailedTeachers = createSelector(getGroupsState, (state: State) => state.failedTeachers);

export const getTeams = createSelector(getGroupsState, (state: State) => state.teams);

export const getCenterTeachers = createSelector(getGroupsState, (state: State) => state.teachers);
